import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { BetslipTeaserPickPointsTrackingData, BetslipTeaserTrackingConstants, BetslipTeaserTrackingData, TrackingEvent } from '../models';

@Injectable()
export class TeaserBetTrackingService {
    constructor(private trackingService: TrackingService) {}

    trackBetslipTeaserPointsSelection(trackingData: BetslipTeaserTrackingData): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, this.getTrackingEventsInfo(trackingData));
    }

    trackBetslipTeaserbetsPickPointsSelection(payload: BetslipTeaserPickPointsTrackingData[]): void {
        this.trackingService.track(trackingConstants.EVENT_TEASER_BETS, this.getTeaserPickPointsTrackingData(payload));
    }

    trackBetslipTeaserPointsInfoSelection(trackingData: BetslipTeaserTrackingData): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, this.getTrackingEventsInfo(trackingData));
    }

    trackBetslipTeaserPicksLoad(trackingData: BetslipTeaserTrackingData): void {
        this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, this.getTrackingEventsInfo(trackingData));
    }

    trackBetslipTeaserTogglePick(trackingData: BetslipTeaserTrackingData): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, this.getTrackingEventsInfo(trackingData));
    }

    private getTrackingEventsInfo(trackingData: BetslipTeaserTrackingData): Partial<TrackData> {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: BetslipTeaserTrackingConstants.CategoryEvent,
            [trackingConstants.COMPONENT_LABEL_EVENT]: BetslipTeaserTrackingConstants.LabelEvent,
            [trackingConstants.COMPONENT_ACTION_EVENT]: trackingData.action,
            [trackingConstants.COMPONENT_POSITION_EVENT]: BetslipTeaserTrackingConstants.PositionEvent,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: trackingData.isLinear
                ? BetslipTeaserTrackingConstants.SourceLinear
                : BetslipTeaserTrackingConstants.SourceTabbed,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: trackingData.eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };
    }

    private getTeaserPickPointsTrackingData(payload: BetslipTeaserPickPointsTrackingData[]): Partial<TrackData> {
        const teaserBets = payload.map((p) => {
            return {
                [trackingConstants.COMPONENT_CATEGORY_EVENT]: BetslipTeaserTrackingConstants.CategoryEvent,
                [trackingConstants.COMPONENT_LABEL_EVENT]: BetslipTeaserTrackingConstants.LabelEvent,
                [trackingConstants.COMPONENT_ACTION_EVENT]: TrackingEvent.Click,
                [trackingConstants.COMPONENT_POSITION_EVENT]: p.isSelected
                    ? BetslipTeaserTrackingConstants.Checked
                    : BetslipTeaserTrackingConstants.Unchecked,
                [trackingConstants.COMPONENT_LOCATION_EVENT]: BetslipTeaserTrackingConstants.LocationEvent,
                [trackingConstants.COMPONENT_EVENT_DETAILS]: p.eventDetails,
                [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
                [trackingConstants.COMPONENT_CONTENT_POSITION]: p.index,
            } as BetslipTeaserTrackingData;
        });

        return { teaserBets } as Partial<TrackData>;
    }

    trackTeaserErrors(trackingData: BetslipTeaserTrackingData): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, this.getTrackingEventsWithAdditionalInfo(trackingData));
    }

    trackTeaserPickRemove(trackingData: BetslipTeaserTrackingData): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, this.getTrackingEventsWithAdditionalInfo(trackingData));
    }

    private getTrackingEventsWithAdditionalInfo(trackingData: BetslipTeaserTrackingData): Partial<TrackData> {
        const trackingTeaserInfo: Record<string, string> = this.getTrackingEventsInfo(trackingData) as Record<string, string>;
        trackingTeaserInfo[trackingConstants.COMPONENT_POSITION_EVENT] = trackingData.positionEvent ?? '';

        return trackingTeaserInfo;
    }
}
